import {immerable} from "immer";
import {PackDto} from "../../../../../models/interfaces/dtos/pack-dto.ts";
import IdItem from "../../../../../models/interfaces/generics/id-item.ts";
import ValidationElement from "./validation-element.ts";
import ValidationState from "../../../../../models/enums/validation-state.ts";

class ValidationPack implements IdItem {
    [immerable] = true;
    
    id: string;
    
    name: string;
    
    storeyId: string;
    
    buildingId: string;
    
    storeyName: string;
    
    buildingName: string;
    
    index: number;
    
    validation: ValidationElement;
    
    isBasement: boolean;
    
    constructor(packDto: PackDto) {
        this.id = packDto.packId;
        this.name = packDto.name;

        this.index = packDto.index;
        this.validation = new ValidationElement(packDto.validation);
        this.isBasement = packDto.isBasement;

        this.storeyId = packDto.storeyId;
        this.storeyName = packDto.storeyName;
        this.buildingId = packDto.buildingId;
        this.buildingName = packDto.buildingName;
    }
    
    updateValidationState(state: ValidationState) {
        this.validation.state = state;
    }
}

export default ValidationPack;